import { useEffect, useState } from 'react';

export function useDraggingOverWindow() {
  const [draggingOverWindow, setDraggingOverWindow] = useState(false);

  function stopDraggingOverWindow() {
    setDraggingOverWindow(false);
  }

  useEffect(() => {
    let lastTarget: Element;

    const handleDragEnter = (event: DragEvent) => {
      lastTarget = event.target as Element;

      setDraggingOverWindow(true);
    };

    const handleDragLeave = (event: DragEvent) => {
      if (event.target === lastTarget) {
        setDraggingOverWindow(false);
      }
    };

    window.addEventListener('dragenter', handleDragEnter);
    window.addEventListener('dragleave', handleDragLeave);

    return () => {
      window.removeEventListener('dragenter', handleDragEnter);
      window.removeEventListener('dragleave', handleDragLeave);
    };
  }, [setDraggingOverWindow]);

  return { draggingOverWindow, stopDraggingOverWindow };
}
